import { render, staticRenderFns } from "./AsiaApplication.vue?vue&type=template&id=903a4158&scoped=true"
import script from "./AsiaApplication.vue?vue&type=script&lang=js"
export * from "./AsiaApplication.vue?vue&type=script&lang=js"
import style0 from "./AsiaApplication.vue?vue&type=style&index=0&id=903a4158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903a4158",
  null
  
)

export default component.exports